import { all, takeLatest, put, call } from 'redux-saga/effects';
import renderNotification from '../../helpers/notifications/renderNotification';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import {
  setPassword,
  setPasswordSucceeded,
  setPasswordFailed,
  forgotPassword,
  forgotPasswordSucceeded,
  forgotPasswordFailed,
  changePassword,
  changePasswordSucceeded,
  changePasswordFailed
} from './slice';
import { onSetPassword, onForgotPassword, onChangePassword } from './api';

const { password_reset_success, password_forgot_success } = NOTIFICATION_MESSAGES;

export function* setPasswordWorker({ payload }) {
  const { token, newPassword, navigate } = payload;
  try {
    yield call(onSetPassword, token, newPassword);
    yield put(setPasswordSucceeded());
    yield call(navigate, '/');
    renderNotification({ type: 'success', message: password_reset_success });
  } catch {
    yield put(setPasswordFailed());
  }
}

export function* forgotPasswordWorker({ payload }) {
  const { email, callback } = payload;
  try {
    yield call(onForgotPassword, email);
    yield put(forgotPasswordSucceeded());

    callback?.();

    renderNotification({
      type: 'success',
      message: password_forgot_success,
      duration: null
    });
  } catch {
    yield put(forgotPasswordFailed());
  }
}

export function* changePasswordWorker({ payload }) {
  const { currentPassword, newPassword, userId, callback } = payload;
  try {
    yield call(onChangePassword, currentPassword, newPassword, userId);
    yield put(changePasswordSucceeded());
    callback?.();
  } catch {
    yield put(changePasswordFailed());
  }
}

export default function* passwordSaga() {
  yield all([
    takeLatest(setPassword.type, setPasswordWorker),
    takeLatest(forgotPassword.type, forgotPasswordWorker),
    takeLatest(changePassword.type, changePasswordWorker)
  ]);
}
